import axios from "axios";
import { POST_RefreshToken } from "./url_helper";
import { user_logout } from "../../services/AuthService";
// import { useNavigate } from "react-router-dom";

//pass new generated access token here
var accessToken =
  "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6ImFkbWluIiwiYWRtaW4iOnRydWUsImp0aSI6ImQ2MTEwYzAxLWMwYjUtNDUzNy1iNDZhLTI0NTk5Mjc2YjY1NiIsImlhdCI6MTU5MjU2MDk2MCwiZXhwIjoxNTkyNTY0NjE5fQ.QgFSQtFaK_Ktauadttq1Is7f9w0SUtKcL8xCmkAvGLw";
const token = accessToken;

// //apply base url for axios
// const API_URL = process.env.REACT_APP_API_BASEURL;

// const axiosApi = axios.create({
//   baseURL: API_URL,
// });

let axiosApi;
// Second instance for the PIF (Tally Integration) API — a separate service on its own
// port/host. Same LIMS bearer token (shared SecretKey); its own base URL from config.json.
let pifAxiosApi;

let config = null;
export const loadConfig = async () => {
  if (config) return config; // Return cached config if already loaded

  try {
    const response = await fetch("/config.json");
    config = await response.json();
  } catch (error) {
    console.error("Failed to load configuration", error);
  }

  return config;
};

// var obj = JSON.parse(localStorage.getItem("userDetails"));
// if (obj && obj.Token) {
//   axiosApi.defaults.headers.common["Authorization"] = "Bearer " + obj.Token;
// } else {
//   axiosApi.defaults.headers.common["Authorization"] = token;
// }
const getLocalAccessToken = () => {
  var obj = JSON.parse(localStorage.getItem("userDetails"));
  if (obj && obj.Token) {
    return obj.Token;
  } else {
    return token;
  }
};

const initializeAxiosApi = async () => {
  const config = await loadConfig();
  let apiBaseUrl;

  const currentHost = window.location.hostname;
  if (
    currentHost === "localhost" ||
    currentHost === "127.0.0.1" ||
    currentHost === "::1" ||
    currentHost.startsWith("192.168.") ||
    currentHost.startsWith("10.") ||
    currentHost.startsWith("172.")
  ) {
    apiBaseUrl = config?.API_BASE_URL_LOCAL_NETWORK; // Local API
  } else {
    apiBaseUrl = config?.API_BASE_URL;
  }

  axiosApi = axios.create({
    baseURL: apiBaseUrl,
  });

  axiosApi.interceptors.request.use(
    (config) => {
      const token = getLocalAccessToken();
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // axiosApi.interceptors.response.use(
  //   (response) => response,
  //   (error) => Promise.reject(error)
  // );

  // ---- Shared token refresh -------------------------------------------------
  // The LIMS token and the PIF token are the same string. The LIMS /RefreshToken
  // endpoint ROTATES the refresh token on every call, so if axiosApi and
  // pifAxiosApi refreshed independently a burst of concurrent 401s would spend
  // the refresh token twice and the second call would fail -> spurious logout.
  // Both instances funnel through this single in-flight promise instead.
  let refreshPromise = null;

  const doRefresh = async () => {
    const obj = JSON.parse(localStorage.getItem("userDetails"));
    if (!obj) throw new Error("no userDetails");
    const res = await axiosApi.post(POST_RefreshToken, {
      RefreshToken: obj?.RefreshToken,
    });
    if (!res?.data?.IsSuccess) throw new Error(res?.data?.Message || "refresh failed");
    obj.Token = res?.data?.Token;
    obj.TokenExpiryDate = res?.data?.TokenExpiryDate;
    obj.RefreshToken = res?.data?.RefreshToken;
    obj.RefreshTokenExpiryDate = res?.data?.RefreshTokenExpiryDate;
    localStorage.setItem("userDetails", JSON.stringify(obj));
    axiosApi.defaults.headers.common["Authorization"] = "Bearer " + res?.data?.Token;
    return res?.data?.Token;
  };

  // Coalesce concurrent callers onto one refresh; clear the slot when it settles.
  const runRefresh = () => {
    if (!refreshPromise) {
      refreshPromise = doRefresh().finally(() => {
        refreshPromise = null;
      });
    }
    return refreshPromise;
  };

  const isRefreshTokenCall = (cfg) =>
    (cfg?.url || "").indexOf(POST_RefreshToken) !== -1;

  // Builds the shared 401 handler for a given axios instance.
  const make401Handler = (instance) => async (error) => {
    const originalRequest = error.config;
    if (
      error?.response?.status === 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !isRefreshTokenCall(originalRequest)
    ) {
      originalRequest._retry = true; // guard against an infinite retry loop
      try {
        const newToken = await runRefresh();
        originalRequest.headers.Authorization = "Bearer " + newToken;
        return instance(originalRequest);
      } catch (refreshError) {
        LogoutAndRedirectToLogin();
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  };

  axiosApi.interceptors.response.use(
    (response) => response,
    make401Handler(axiosApi)
  );

  // ---- PIF (Tally Integration) API instance ------------------------------
  let pifBaseUrl;
  if (
    currentHost === "localhost" ||
    currentHost === "127.0.0.1" ||
    currentHost === "::1" ||
    currentHost.startsWith("192.168.") ||
    currentHost.startsWith("10.") ||
    currentHost.startsWith("172.")
  ) {
    pifBaseUrl = config?.PIF_API_BASE_URL_LOCAL_NETWORK;
  } else {
    pifBaseUrl = config?.PIF_API_BASE_URL;
  }

  pifAxiosApi = axios.create({ baseURL: pifBaseUrl });

  pifAxiosApi.interceptors.request.use(
    (cfg) => {
      const t = getLocalAccessToken();
      if (t) {
        cfg.headers["Authorization"] = `Bearer ${t}`;
      }
      return cfg;
    },
    (error) => Promise.reject(error)
  );

  // The PIF token is the same LIMS token. On a 401, refresh it (coalesced with
  // any in-flight LIMS refresh via runRefresh — see "Shared token refresh"
  // above) so a user sitting on a PIF screen past the token lifetime isn't
  // kicked to login, then retry. If the refresh itself fails, log out.
  pifAxiosApi.interceptors.response.use(
    (response) => response,
    make401Handler(pifAxiosApi)
  );
};

// Initialize Axios API when the app starts
initializeAxiosApi();

export async function get(url, config = {}) {
  return await axiosApi
    .get(url, { ...config })
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response.data);
}
export async function postFormData(url, data) {
  return axiosApi
    .post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.data);
}

// ---- PIF (Tally Integration) API calls ----------------------------------
export async function pifGet(url, config = {}) {
  return pifAxiosApi.get(url, { ...config }).then((response) => response.data);
}

export async function pifPost(url, data, config = {}) {
  return pifAxiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

// Same as pifPost but sends `data` as-is (for array request bodies — pifPost's
// object spread would turn an array into {0:..,1:..}).
export async function pifPostRaw(url, data, config = {}) {
  return pifAxiosApi
    .post(url, data, { ...config })
    .then((response) => response.data);
}

export const setAuthToken = (token) => {
  //this function is use to set new token to axios api instance login time
  axiosApi.defaults.headers.common["Authorization"] = "Bearer " + token;
};

export const LogoutAndRedirectToLogin = () => {
  //const navigate = useNavigate();

  //logout & redirect to login screen
  var obj = JSON.parse(localStorage.getItem("userDetails"));
  if (obj) {
    user_logout(obj?.LoginIDEncrypt);
  }
  localStorage.removeItem("userDetails");
  //navigate("/login");
  window.location = "/login";
};
